import React from 'react';
import { FiAlertCircle, FiRefreshCw, FiArrowLeft } from 'react-icons/fi';
import './ParentErrorState.css';

const variants = {
  'load-failed': {
    title: 'Unable to load student data',
    description: 'Something went wrong while loading the data. Please try again.',
  },
  'assignments-failed': {
    title: 'Unable to load assignments',
    description: 'We could not load assignment data at this time.',
  },
  'report-failed': {
    title: 'Unable to load report',
    description: 'The report could not be loaded. Please try again later.',
  },
  'connection-failed': {
    title: 'Connection request failed',
    description: 'We were unable to process the connection request. Please try again.',
  },
  'creation-failed': {
    title: 'Student profile creation failed',
    description: 'Something went wrong creating the student profile.',
  },
  'no-permission': {
    title: 'No permission to view this student',
    description: 'You do not have access to view this student\'s data. Please check your connections.',
  },
};

function ParentErrorState({ variant = 'load-failed', onRetry, onBack }) {
  const config = variants[variant] || variants['load-failed'];

  return (
    <div className="parent-error-state" role="alert">
      <div className="parent-error-state__icon">
        <FiAlertCircle size={32} />
      </div>
      <h3 className="parent-error-state__title">{config.title}</h3>
      <p className="parent-error-state__description">{config.description}</p>
      <div className="parent-error-state__actions">
        {onRetry && (
          <button className="parent-error-state__retry" onClick={onRetry}>
            <FiRefreshCw size={14} />
            Try Again
          </button>
        )}
        {onBack && (
          <button className="parent-error-state__back" onClick={onBack}>
            <FiArrowLeft size={14} />
            Go Back
          </button>
        )}
      </div>
    </div>
  );
}

export default ParentErrorState;
